import React from "react";

import { useAndSetWidgets } from "../../api/widgets/get-widgets";
import IgErrorBoundary from "../../components/Utils/IgErrorBoundary";
import { useViewPage } from "../../hooks/mixpanel";
import Loading from "../../utils/Loading";

import { WidgetLibraryBody } from "./WidgetLibrary.body";

export const WidgetLibraryRoute = () => {
  const widgets = useAndSetWidgets();

  useViewPage("Widget Library");
  if (!widgets.isSuccess) {
    return <Loading />;
  }
  return (
    <IgErrorBoundary>
      <WidgetLibraryBody />
    </IgErrorBoundary>
  );
};
